import React from 'react';
import { BarChart3 } from 'lucide-react';

const MiniChart = ({ data, label, color }) => {
  // Ensure data is an array with valid items
  const validData = Array.isArray(data) && data.length > 0 
    ? data.filter(d => d && typeof d.count === 'number')
    : [];
  
  const maxVal = validData.length > 0 
    ? Math.max(...validData.map(d => d.count), 1) 
    : 1;
  const total = validData.reduce((sum, d) => sum + (d.count || 0), 0);
  
  return (
    <div className="bg-gradient-to-br from-[#2D063E] to-[#1a0527] border border-[#4A0A66]/50 rounded-xl p-4">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-white flex items-center gap-2">
          <BarChart3 className="w-4 h-4" style={{ color }} />
          {label}
        </h3>
        <span className="text-xs font-bold" style={{ color }}>{total} total</span>
      </div>
      <div className="flex items-end gap-1 h-20">
        {validData.length > 0 ? validData.map((item, idx) => (
          <div key={item.date || `chart-item-${idx}`} className="flex-1 flex flex-col items-center gap-1">
            {item.count > 0 && (
              <span className="text-[10px] font-bold" style={{ color }}>{item.count}</span>
            )}
            <div 
              className="w-full rounded-t transition-all duration-300 hover:opacity-80 hover:scale-105"
              style={{ 
                height: item.count > 0 ? `${Math.max((item.count / maxVal) * 100, 15)}%` : '3px',
                backgroundColor: item.count > 0 ? color : '#4A0A66',
                boxShadow: item.count > 0 ? `0 0 8px ${color}50` : 'none'
              }}
            />
            <span className="text-[9px] text-[#FDF2F8]/60">{item.date?.split(' ')[1] || idx}</span>
          </div>
        )) : (
          <div className="flex-1 flex items-center justify-center text-[#FDF2F8]/40 text-xs">
            No data
          </div>
        )}
      </div>
    </div>
  );
};

export default MiniChart;
